import * as React from "react"
import * as PopoverPrimitive from "@radix-ui/react-popover"

import { cn } from "../../lib/utils"

function Popover({
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Root>) {
  return <PopoverPrimitive.Root data-slot="popover" {...props} />
}

function PopoverTrigger({
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Trigger>) {
  return <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />
}

function PopoverContent({
  className,
  align = "center",
  sideOffset = 4,
  side = 'bottom',
  portal = true,
  portalContainer,
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Content> & {
  portal?: boolean;
  portalContainer?: HTMLElement | null;
}) {
  const content = (
    <PopoverPrimitive.Content
      data-slot="popover-content"
      side={side}
      align={align}
      sideOffset={sideOffset}
      className={cn(
         "outline-none bg-popover text-popover-foreground w-[var(--radix-popover-trigger-width)] origin-[var(--radix-popover-content-transform-origin)] origin-center rounded-md border border-input p-4 shadow-md",
        "data-[state=open]:animate-animate-in",
        "data-[state=closed]:animate-animate-out",
        "data-[side=bottom]:animate-slide-in-from-top-2",
        "data-[side=top]:animate-slide-in-from-bottom-2",
        "data-[side=left]:animate-slide-in-from-right-2",
        "data-[side=right]:animate-slide-in-from-left-2",
        className
      )}
      style={{
        zIndex: '99999993',
      }}
      {...props}
    />
  );

  if (!portal) {
    return content;
  }

  return (
    <PopoverPrimitive.Portal container={portalContainer ?? undefined}>
      {content}
    </PopoverPrimitive.Portal>
  )
}

function PopoverAnchor({
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Anchor>) {
  return <PopoverPrimitive.Anchor data-slot="popover-anchor" {...props} />
}

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor }
